import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../../providers/AuthProvider';

/** Force first-run profile completion before accessing the main app. */
export function ProfileGate({ children }: { children: ReactNode }) {
  const { profileComplete } = useAuth();
  if (!profileComplete) return <Navigate to="/profile/setup" replace />;
  return <>{children}</>;
}
